export default {
  fgtColor: '#3791D3',
  primary: '#3791D3',
  secondary: '#D34637',
  success: '#36BF26',
  error: '#FF4D4A',
  disabled: '#D8D8D8',
}
